import { Disclosure } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";

const faqs = [
  {
    question: "Which forms are created by using REINSW PDF Agreements on Demand?",
    answer: "You can create any of the following forms:",
    listItems: [
      "FM00150: Exclusive Management Agency Agreement",
      "FM00401: Residential Tenancy Agreement",
      "FM00409: Condition Report",
      "FM00900: Commercial Lease",
      "SA00050: Buyers' Agency Agreement",
      "SA00200: Exclusive Selling Agreement",
      "SA00300: Auction Agency Agreement",
      "SA00500: Conjunction Agreement",
      "SA00720: Rural Exclusive Agency Agreement",
      /* "SA00301: Auction Bidders Record Cards",
      "SA00302: Auction Bidders Registration Cards", */
    ],
  },
  {
    question: "Who is REINSW PDF Agreements on Demand meant for?",
    answer:
      "REINSW PDF Agreements on Demand is for anyone who needs to create a form for a property located within New South Wales, for a one time fee.",
  },

  {
    question:
      "What if I've made a mistake while completing the forms but have already paid for it?",
    answer: (
      <>
        Not a problem! Simply get in contact with the team at{" "}
        <a
          className="text-blue-600 underline"
          target="blank"
          rel="noreferrer"
          href="mailto:reinsw@reinsw.com.au"
        >
          reinsw@reinsw.com.au
        </a>{" "}
        and we'll resolve the issue.
      </>
    ),
  },

  {
    question:
      "What if the property that the form is being created for is in a different state?",
    answer: (
      <>
        If the property is outside of New South Wales, please visit{" "}
        <a
          className="text-blue-600 underline"
          target="blank"
          rel="noreferrer"
          href="https://reia.com.au/contact-us/"
        >
          https://reia.com.au/contact-us/
        </a>{" "}
        for contact details of the relevant REI in each state.
      </>
    ),
  },
  {
    question:
      "What do I do if the property is located in New South Wales but I need a different form?",
    answer: (
      <>
        If you need a different form, please contact{" "}
        <a
          className="text-blue-600 underline"
          target="blank"
          rel="noreferrer"
          href="mailto:reinsw@reinsw.com.au"
        >
          reinsw@reinsw.com.au
        </a>{" "}
        to see a list of your options.
      </>
    ),
  },
];

function classNames(...questions) {
  return questions.filter(Boolean).join(" ");
}

export default function FAQ() {
  return (
    <div className="bg-white min-h-[55vh]">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:py-16 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto divide-y-2 divide-gray-200">
          <h2 className="text-center text-4xl mb-12 font-extrabold text-gray-700">
            Frequently Asked Questions
          </h2>
          <dl className="mt-6 space-y-6 divide-y divide-gray-200">
            {faqs.map((faq) => (
              <Disclosure as="div" key={faq.question} className="pt-6">
                {({ open }) => (
                  <>
                    <dt className="text-lg">
                      <Disclosure.Button className="text-left w-full flex justify-between items-start text-gray-400">
                        <span className="text-xl font-semibold text-gray-700">
                          {faq.question}
                        </span>
                        <span className="ml-6 h-7 flex items-center">
                          <ChevronDownIcon
                            className={classNames(
                              open ? "-rotate-180" : "rotate-0",
                              "h-6 w-6 transform"
                            )}
                            aria-hidden="true"
                          />
                        </span>
                      </Disclosure.Button>
                    </dt>
                    <Disclosure.Panel as="dd" className="mt-2 pr-12">
                      <p className="text-base text-gray-500">{faq.answer}</p>
                      {faq.paragraphs &&
                        faq.paragraphs.length &&
                        faq.paragraphs.map((paragraph) => {
                          return (
                            <p className="text-base text-gray-500 mt-2">
                              {paragraph}
                            </p>
                          );
                        })}
                      {faq.listItems &&
                        faq.listItems.length &&
                        faq.listItems.map((item) => {
                          return (
                            <ul>
                              <li className="text-base text-gray-500 list-disc ml-6">
                                {item}
                              </li>
                            </ul>
                          );
                        })}
                    </Disclosure.Panel>
                  </>
                )}
              </Disclosure>
            ))}
          </dl>
        </div>
      </div>
    </div>
  );
}
